import { S as Swiper } from './swiper-core-BXF75Fx2.js';
import { A as Autoplay } from './autoplay-CsPtyn3v.js';

/**
 * Custom element for displaying customer service cards as a Swiper carousel.
 * Initializes Swiper slider with responsive design matching Figma specs.
 */
class CustomerServiceCards extends HTMLElement {
  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    this.init();
  }

  /**
   * Initialize the customer service cards slider.
   */
  init() {
    this.initSwiper();
  }

  /**
   * Get autoplay configuration for Swiper.
   * @param {Element} swiperEl
   * @returns {Object|false}
   */
  getAutoplayConfig(swiperEl) {
    const autoplay = swiperEl?.dataset.autoplay === 'true';
    const delay = parseInt(swiperEl?.dataset.autoplayDelay) || 5000;

    if (!autoplay) return false;

    return {
      delay,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
  }

  /**
   * Initialize Swiper for customer service cards slider.
   */
  initSwiper() {
    const swiperEl = this.querySelector('.swiper--customer-service-cards');

    if (!swiperEl) {
      console.warn('Customer service cards slider: Swiper element not found');
      return;
    }

    const loop = swiperEl?.dataset.loop === 'true';
    const autoplay = this.getAutoplayConfig(swiperEl);

    const swiperOptions = {
      modules: [Autoplay],
      spaceBetween: 16,
      slidesPerView: 'auto',
      watchOverflow: true,
      autoplay,
      loop,
      // Ensure equal height for all slides
      autoHeight: false,
    };

    try {
      const swiper = new Swiper(swiperEl, swiperOptions);
      // Store swiper instance for potential future reference
      this.swiper = swiper;
    } catch (error) {
      console.error('Error initializing Customer service cards Slider:', error);
    }
  }

  /**
   * Destroy the Swiper instance when element is removed.
   */
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('customer-service-cards', CustomerServiceCards);
